import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Grid } from '@/components/Grid';
import { Icon } from '@/components/Icon';
import { Typography } from '@/components/Typography';

import { DownloadLink } from './components';

export const SwissMade = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    color: ${theme.colors.darkError};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.p3};
  `}
`;

export const LinkWrapperMobile = styled(DownloadLink)`
  display: flex;
  justify-content: center;
  text-decoration: none;

  ${({ theme }) => css`
    margin-top: ${theme.space.s100};
    ${theme.mediaQueries.md} {
      display: none !important;
    }
  `}
`;

export const LinkWrapper = styled(LinkWrapperMobile)`
  display: none;
  ${({ theme }) => css`
    margin-top: 0;
    ${theme.mediaQueries.md} {
      display: flex !important;
      margin-left: ${theme.space.s150};
    }
  `}
`;

export const ChevronIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.primary};
`;

export const KeyFeatures = styled(Grid)`
  grid-template-columns: repeat(3, 1fr);

  ${({ theme }) => css`
    margin: ${theme.spacing(3)} 0 ${theme.spacing(3)};
    row-gap: ${theme.spacing(1.5)};

    ${theme.media.md.up} {
      margin: ${theme.spacing(3)} 0 ${theme.spacing(1)};
      row-gap: ${theme.spacing(2)};
      padding: 0 ${theme.spacing(7)};
      grid-template-columns: repeat(6, 1fr);
    }
  `}
`;

export const Line = styled(Box)`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.mediumGrey};
`;
